import axios from "axios";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import Row from "react-bootstrap/Row";
import { useRazorpay } from "react-razorpay";
import { useLocation, useNavigate } from "react-router-dom";
import safetyImg from "../../assets/safety-image.jpg";
import { useAuth } from "../../contexts/AuthContext";
import { initializeCashfree } from "../../gateway/cashfree";
import { createOrder } from "../../gateway/phonepe";
import PaytmIntentPayment from "../PaytmIntentPayment";
import "./index.css";

const Cart = () => {
  const [loading, setLoading] = useState(false);
  const [showPaytmIntent, setShowPaytmIntent] = useState(false);
  const { Razorpay } = useRazorpay();
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("address"));
  const userProductData = JSON.parse(localStorage.getItem("slectedData"));

  const {
    cartProducts,
    handleSetCartProducts,
    totalPrice,
    totalDiscount,
    totalMRP,
    selectedProduct,
    handleSelectProduct,
    setSelectedProduct,
    setStep,
    themColor,
    totalExtraDiscount,
    isMobile,
  } = useAuth();

  const { routeChange } = location.state || {};
  const [showOffCanvas, setShowOffCanvas] = useState({
    show: false,
    size: false,
    product: {},
  });

  useEffect(() => {
    if (cartProducts?.length > 0) {
      setSelectedProduct(cartProducts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartProducts]);

  const handlePhonePayPayment = async () => {
    // const data = {
    //   name: address.fullname,
    //   mobileNumber: address.mobile,
    //   amount: totalPrice,
    //   merchantkey: process.env.REACT_APP_PHONEPE_MKEYS,
    //   merchantid: process.env.REACT_APP_PHONEPE_MIDS,
    //   domainname: window.location.hostname,
    //   noderedirectUrl: process.env.REACT_APP_PHONEPE_NODE_URL,
    // };

    // try {
    //   setLoading(true);
    //   const res = await axios.post(
    //     `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/phonepay/create-order`,
    //     data
    //   );

    //   if (res.data?.data?.instrumentResponse?.redirectInfo?.url) {
    //     window.open(res.data.data.instrumentResponse.redirectInfo.url, "_self");
    //   }
    // } catch (error) {
    //   console.error("Error in payment:", error);
    // } finally {
    //   setLoading(false);
    // }
    const domainname = window.location.hostname;
    const amount = totalPrice;

    try {
      setLoading(true);
      const checkoutUrl = await createOrder(amount, domainname);
      window.location.href = checkoutUrl;
    } catch (error) {
      alert("Payment initiation failed. Try again!");
    } finally {
      setLoading(false);
    }
  };

  const handleRazorpayPayment = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/razorpay/create-order`,
        {
          amount: totalPrice,
          currency: "INR",
          razorpaykeyid: process.env.REACT_APP_RAZORPAY_KEY_ID,
          razorpaykeysecret: process.env.REACT_APP_RAZORPAY_KEY_SECRET,
        },
      );

      const domainname = window.location.hostname;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data?.order?.amount,
        currency: data?.order?.currency,
        order_id: data?.order?.id, // ✅ Add this line
        name: window.location.hostname,
        description: "",
        image: process.env.REACT_APP_LOGO,
        handler: async (response) => {
          const redirectUrl = `https://${domainname}/payment-status?orderId=${encodeURIComponent(
            response.razorpay_order_id.replace("order_", ""),
          )}&razorpay_order_id=${encodeURIComponent(response.razorpay_order_id)}&razorpay_payment_id=${encodeURIComponent(
            response.razorpay_payment_id,
          )}&razorpay_signature=${encodeURIComponent(response.razorpay_signature)}&razorpay_secret=${encodeURIComponent(process.env.REACT_APP_RAZORPAY_KEY_SECRET)}`;
          window.location.href = redirectUrl;
        },
        prefill: {
          name: window.location.hostname,
          // email: `support@${window.location.hostname}.com`,
          contact: userDetails.mobile,
        },
        notes: {
          address: userDetails.address1,
        },
        theme: {
          color: process.env.REACT_APP_THEAM_COLOR,
        },
        modal: {
          ondismiss: function () {
            window.location.href = `https://${window.location.hostname}/cart`;
          },
        },
      };

      const razorpay = new Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error("Error initiating payment:", err);
    }
  };

  const getSessionId = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/cashfree/create-order`,
        {
          cashfreeappid: process.env.REACT_APP_CASHFREE_APP_ID,
          cashfreesecretkey: process.env.REACT_APP_CASHFREE_SECRET_KEY,
          domainname: window.location.hostname,
          amount: totalPrice,
          customerphone: `+91${userDetails?.mobile}`,
          customername: userDetails?.fullname,
        },
      );
      if (response && response.data.payment_session_id) {
        localStorage.setItem("cashfree_order_id", response.data.order_id);
        return response.data.payment_session_id;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCashFreePayPayment = async () => {
    try {
      let sessionId = await getSessionId();

      if (!sessionId) {
        console.error("Payment session ID or Cashfree SDK not initialized");
        return;
      }

      const cashfree = await initializeCashfree();

      if (!cashfree) {
        alert("Cashfree not configured properly.");
        setLoading(false);
        return;
      }

      cashfree.checkout({
        paymentSessionId: sessionId,
        redirectTarget: "_self",
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleIndianPayPayment = async () => {
    const data = {
      name: userDetails?.fullname,
      mobile: `+91${userDetails?.mobile}`,
      amount: totalPrice,
      domainname: window.location.hostname,
      email: "",
      remark: "",
      type: "",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/pay/create-order`,
        data,
      );
      if (response.data?.payment_link) {
        window.open(response.data?.payment_link, "_self");
      }
    } catch (error) {
      console.error("Error in payment:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const PayUPayPayment = async () => {
    const data = {
      firstname: userDetails?.fullname,
      phone: `+91${userDetails?.mobile}`,
      amount: totalPrice,
      domainname: window.location.hostname,
      email: "test@gmail.com",
      productinfo: "Product Description",
    };
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/payu/initiate-payment`,
        data,
      );
      setLoading(false);
      const parser = new DOMParser();
      const doc = parser.parseFromString(res.data, "text/html");
      const form = doc.querySelector("form");
      if (form) {
        document.body.appendChild(form);
        form.submit(); // 🚀 Redirects to PayU gateway
      } else {
        console.error("Form not found in PayU response.");
      }
    } catch (err) {
      console.error("Payment initiation failed:", err);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  // Paytm Integration
  useEffect(() => {
    if (process.env.REACT_APP_PAYMENT_TYPE !== "paytm") return;
    const mid = process.env.REACT_APP_PAYTM_MID;
    if (!mid) {
      console.warn(
        "⚠️ Paytm MID not found in environment variables — skipping Paytm SDK load",
      );
      return;
    }
    const script = document.createElement("script");
    script.src = `https://secure.paytmpayments.com/merchantpgpui/checkoutjs/merchants/${mid}.js`;
    script.type = "application/javascript";
    script.async = true;

    script.onload = () => {
      // console.log("✅ Paytm SDK loaded");
      window.paytmReady = true; // mark flag
    };

    script.onerror = () => console.error("❌ Failed to load Paytm SDK");
    document.body.appendChild(script);

    return () => document.body.removeChild(script);
  }, []);

  const paytmPayment = async () => {
    try {
      if (!window.paytmReady || !window.Paytm?.CheckoutJS) {
        alert("⚠️ Paytm SDK is still loading. Please try again in a moment.");
        return;
      }
      setLoading(true);

      const orderId = "ORDERID_" + new Date().getTime();
      const customerId = "CUST_" + new Date().getTime();
      const amount = totalPrice;
      const { data } = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/paytm/create-order`,
        {
          amount,
          orderId,
          customerId,
          paytmmid: process.env.REACT_APP_PAYTM_MID,
          paytmkey: process.env.REACT_APP_PAYTM_KEY,
          domainname: window.location.hostname,
          name: userDetails?.fullname,
          mobile: `+91${userDetails?.mobile}`,
        },
      );

      if (!data?.txnToken)
        throw new Error("Failed to get transaction token from server.");

      // Configure Paytm CheckoutJS
      const config = {
        root: "",
        flow: "DEFAULT",
        data: {
          orderId: data.orderId,
          token: data.txnToken,
          tokenType: "TXN_TOKEN",
          amount: data.amount,
          mid: data.mid,
          userInfo: {
            custId: customerId,
            firstName: userDetails?.fullname || "",
            mobile: `+91${userDetails?.mobile}` || "",
          },
        },
        handler: {
          notifyMerchant: function (eventName, info) {
            console.log("🔔 Paytm Event:", eventName, info);

            // 👇 Detect close/back event and redirect
            if (eventName === "APP_CLOSED") {
              window.location.href = `https://${window.location.hostname}/cart`;
            }
          },
          transactionStatus: function (paymentStatus) {
            // window.location.href = `https://${window.location.hostname}/payment-status?orderId=${data.orderId}`;
          },
        },
      };
      // console.log("🧩 Paytm SDK Object:", window.Paytm.CheckoutJS);

      window.Paytm.CheckoutJS.init(config)
        .then(() => {
          // console.log("✅ Paytm Checkout initialized");
          window.Paytm.CheckoutJS.invoke();
        })
        .catch((error) => {
          console.error("❌ Paytm init failed:", error);
        });
    } catch (error) {
      console.error("Payment Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const rupixpePayment = async () => {
    const data = {
      firstname: userDetails?.fullname,
      phone: userDetails?.mobile,
      amount: totalPrice,
      domainname: window.location.hostname,
      email: "test@gmail.com",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/rupixpe/create-order`,
        data,
      );

      window.open(response.data.data.payment_url, "_blank");
    } catch (error) {
      console.error("Payment initiation failed:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const randomTxnId = Math.floor(10000000 + Math.random() * 90000000);

  const loadEasebuzzScript = () => {
    return new Promise((resolve, reject) => {
      if (window.EasebuzzCheckout) return resolve(true);

      const script = document.createElement("script");
      script.src =
        "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/easebuzz-checkout.js";
      script.async = true;

      script.onload = () => resolve(true);
      script.onerror = () => reject("Easebuzz SDK failed to load");

      document.body.appendChild(script);
    });
  };

  const handleEasebuzzPayment = async () => {
    try {
      setLoading(true);

      // 1️ Call backend to create order
      const res = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/easebuzz/create-order`,
        {
          amount: totalPrice,
          customername: userDetails?.fullname || "User",
          email: userDetails?.email || "user@test.com",
          customerphone: userDetails?.mobile,
          domainname: window.location.hostname,
        },
      );

      const order = res.data;

      if (!order?.data) {
        throw new Error("Easebuzz access key missing");
      }

      // 2️ Load Easebuzz SDK
      await loadEasebuzzScript();

      // 3️ Open Easebuzz MODAL
      const easebuzz = new window.EasebuzzCheckout(
        process.env.REACT_APP_EASEBUZZ_KEY,
        order.env || "prod", // must match backend
      );

      easebuzz.initiatePayment({
        access_key: order.data,

        onResponse: async function (response) {
          console.log(" Easebuzz response:", response);

          try {
            const orderDetails = {
              products: userProductData,
              address: userDetails,
            };
            const verifyRes = await axios.post(
              `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/easebuzz/verify-payment`,
              {
                txnid: order.txnid,
                amount: totalPrice,
                email: userDetails?.email || "user@test.com",
                phone: userDetails?.mobile,
                domainname: window.location.hostname,
                orderDetails,
              },
            );
            const paymentStatus = verifyRes?.data?.gatewayResponse?.status;
            console.log("verifyRes.data", paymentStatus);

            // 5️ Success redirect

            if (paymentStatus === "success") {
              navigate(`/thankyou?txnId=${order.txnid}`);
            } else {
              navigate("/cart");
            }
          } catch (verifyErr) {
            console.error(" Easebuzz verify failed", verifyErr);
          }
        },
        // theme: process.env.REACT_APP_THEAM_COLOR || "#3399cc",
      });
    } catch (err) {
      console.error("Easebuzz error:", err);
    } finally {
      setLoading(false);
    }
  };

  const pineLabPayment = async () => {
    try {
      setLoading(true);

      const data = {
        name: userDetails?.fullname,
        phone: `${userDetails?.mobile}`,
        amount: totalPrice,
        domainname: window.location.hostname,
        pineMid: process.env.REACT_APP_PINELAB_MID || '',
        pineClientId: process.env.REACT_APP_PINELAB_CLIENT_ID || '',
        pineClientSecret: process.env.REACT_APP_PINELAB_CLIENT_SECRET || '',
      };

      const res = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/pine/initiate-payment`,
        data
      );

      if (res.data?.success && res.data?.paymentUrl) {
        window.location.href = res.data.paymentUrl;
      } else {
        alert("Payment initiation failed");
      }

    } catch (error) {
      console.log("PineLab Payment Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const payNow = async () => {
    const paymentType = process.env.REACT_APP_PAYMENT_TYPE;
    if (paymentType === "razorpay") {
      handleRazorpayPayment();
    } else if (paymentType === "phonepe") {
      handlePhonePayPayment();
    } else if (paymentType === "cashfree") {
      handleCashFreePayPayment();
    } else if (paymentType === "indianpay") {
      handleIndianPayPayment();
    } else if (paymentType === "payu") {
      PayUPayPayment();
    } else if (paymentType === "paytm") {
      paytmPayment();
    } else if (paymentType === "paytm-intent") {
      setShowPaytmIntent(true);
    } else if (paymentType === "rupixpe") {
      rupixpePayment();
    } else if (paymentType === "easebuzz") {
      handleEasebuzzPayment();
    } else if (paymentType === "pinelab") {
      pineLabPayment();
    } else if (paymentType === "cod") {
      navigate(`/thankyou?txnId=${randomTxnId}`);
    } else {
      setLoading(true);
    }
  };

  localStorage.setItem("totalPrice", totalPrice);
  function calculateDiscount(compareAtPrice, price) {
    // Convert string values to numbers
    const actualPrice = parseFloat(price);
    let mrp =
      compareAtPrice && parseFloat(compareAtPrice) > 0
        ? parseFloat(compareAtPrice)
        : actualPrice * 3;

    // Ensure MRP is greater than 0 to avoid division errors
    if (mrp <= 0) {
      console.error("Invalid MRP or price values");
      return 0;
    }

    // Calculate discount percentage
    const discountPercentage = ((mrp - actualPrice) / mrp) * 100;
    return discountPercentage.toFixed(2); // Round to 2 decimal places
  }

  return (
    <>
      {showPaytmIntent && (
        <PaytmIntentPayment
          amount={totalPrice}
          userDetails={userDetails}
          onClose={() => setShowPaytmIntent(false)}
        />
      )}
      {isMobile ? (
        <div>
          <Container className="h-100 d-flex flex-column justify-content-between">
            <div>
              {loading &&
                (isMobile ? (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      background: "rgba(255,255,255,0.8)",
                      zIndex: 9999999999,
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: "15%",
                        left: "45%",
                      }}
                    >
                      <Spinner />
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      position: "fixed",
                      width: "100%",
                      height: "100vh",
                      background: "rgba(255,255,255,0.8)",
                      zIndex: 9999999999,
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "35%",
                        left: "35%",
                      }}
                    >
                      <Spinner />
                    </div>
                  </div>
                ))}
              {cartProducts?.length === 0 && (
                <Row>
                  <Col>
                    <div
                      style={{
                        boxShadow: "1px 1px 11px 1px #ddd",
                        padding: "10px",
                        marginTop: "20px",
                        borderRadius: "15px",
                        width: "100%",
                        minHeight: "250px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Outline"
                          viewBox="0 0 24 24"
                          width="50"
                          height="50"
                        >
                          <path d="M21,6H18A6,6,0,0,0,6,6H3A3,3,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A3,3,0,0,0,21,6ZM12,2a4,4,0,0,1,4,4H8A4,4,0,0,1,12,2ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A1,1,0,0,1,3,8H6v2a1,1,0,0,0,2,0V8h8v2a1,1,0,0,0,2,0V8h3a1,1,0,0,1,1,1Z" />
                        </svg>
                      </div>
                      <h2
                        className="mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        Your cart is empty
                      </h2>
                      <div className="Footer__Content Rte">
                        Let's go Buy Somthing!
                      </div>
                      <Button
                        variant="dark"
                        className="btn my-3 primary d-flex justify-content-center align-items-center ripple animated"
                        style={{
                          padding: "10px 20px",
                          background: "var(--them-color)",
                          borderColor: "var(--them-color)",
                        }}
                        onClick={(e) => {
                          e?.target?.classList?.add("bounceIn");
                          navigate(`/ `);
                          setTimeout(() => {
                            if (e?.target?.classList?.contains("bounceIn"))
                              e?.target?.classList?.remove("bounceIn");
                          }, 1000);
                        }}
                      >
                        Shop Now
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
              {cartProducts?.length > 0 && (
                <Row>
                  <Col
                    md={12}
                    xs={12}
                    style={{
                      fontWeight: "bold",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {" "}
                    <span style={{ fontSize: "16px" }}>
                      <Form.Check
                        className="custom-check-box d-flex"
                        type={"checkbox"}
                        checked={selectedProduct?.length > 0}
                        onChange={(e) => {
                          e.stopPropagation();
                          if (selectedProduct?.length > 0) {
                            setSelectedProduct([]);
                          } else {
                            setSelectedProduct(cartProducts);
                          }
                        }}
                      />
                    </span>
                    <span className="ms-2">{`${selectedProduct?.length || 0}/${cartProducts?.length || 0
                      } ITEMS SELECTED`}</span>
                    <span
                      style={{
                        color: "#ff4e4e",
                        marginLeft: "5px",
                      }}
                    >
                      ₹{totalPrice}
                    </span>
                  </Col>
                </Row>
              )}
              <Row className="g-2">
                {cartProducts?.map((item) => (
                  <Col key={item.id} xs={12} md={12}>
                    <Card className="flex-row align-items-center position-relative">
                      <div
                        className="product-select-box"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectProduct(item?.id);
                        }}
                      >
                        <Form.Check
                          className="custom-check-box d-flex"
                          type={"checkbox"}
                          checked={selectedProduct?.some(
                            (o) => o.id === item.id,
                          )}
                          onChange={() => { }}
                        />
                      </div>
                      <div
                        className="product-delete-box"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (selectedProduct?.find((o) => o.id === item.id)) {
                            handleSelectProduct(item.id);
                          }
                          const selectedItem = cartProducts.filter(
                            (o) => o.id !== item.id,
                          );
                          handleSetCartProducts(selectedItem);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill="#000"
                            fillRule="evenodd"
                            d="M9.031 8l6.756-6.756a.731.731 0 0 0 0-1.031.732.732 0 0 0-1.031 0L8 6.969 1.244.213a.732.732 0 0 0-1.031 0 .731.731 0 0 0 0 1.03L6.969 8 .213 14.756a.731.731 0 0 0 0 1.031.732.732 0 0 0 1.031 0L8 9.031l6.756 6.756a.732.732 0 0 0 1.031 0 .731.731 0 0 0 0-1.03L9.031 8z"
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{
                          width: "250px",
                          height: "196px",
                          padding: "10px",
                          borderRadius: "6px",
                        }}
                      >
                        <Card.Img
                          variant="top"
                          src={item?.images?.[0]?.src}
                          style={{
                            height: "100%",
                            minWidth: "100%",
                            borderRadius: "6px",
                            objectFit: "contain",
                          }}
                          onClick={() => {
                            navigate(`/ single - product / ${item.handle} `, {
                              state: {
                                handle: item?.handler,
                              },
                            });
                          }}
                        />
                      </div>
                      <Card.Body style={{ textAlign: "start" }}>
                        <Card.Subtitle className="text-ellips">
                          {item.title}
                        </Card.Subtitle>
                        <Card.Text className="d-flex align-items-center mt-2 mb-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill="#FF3F6C"
                              d="M7.998 4c-2.674 0-5.1 1.57-6.888 4.12a.625.625 0 000 .709c1.789 2.552 4.214 4.122 6.888 4.122 2.674 0 5.099-1.57 6.888-4.12a.629.629 0 000-.709C13.096 5.57 10.672 4 7.998 4zm.192 7.627c-1.775.12-3.241-1.45-3.13-3.357.092-1.573 1.28-2.848 2.746-2.946 1.775-.12 3.24 1.45 3.13 3.357-.095 1.57-1.283 2.845-2.746 2.946zm-.09-1.456c-.955.064-1.746-.78-1.683-1.806.05-.848.69-1.533 1.48-1.588.957-.065 1.747.78 1.684 1.806-.051.85-.693 1.536-1.48 1.588z"
                            ></path>
                          </svg>
                          <span
                            className=""
                            style={{
                              fontSize: "12px",
                              fontWeight: 700,
                              paddingLeft: "3px",
                              color: "#282c3f",
                            }}
                          >
                            {Math.floor(Math.random() * 31) + 50}
                          </span>
                          <span
                            className=""
                            style={{
                              color: "#94969f",
                              fontSize: "12px",
                              paddingLeft: "3px",
                            }}
                          >
                            People viewing now
                          </span>
                        </Card.Text>

                        <Card.Text className="mt-1">
                          {item?.size?.length > 0 && (
                            <div
                              className="itemComponents-base-quantity me-2"
                              onClick={(e) => {
                                e?.stopPropagation();
                                setShowOffCanvas((prev) => ({
                                  show: !prev.show,
                                  size: true,
                                  product: item,
                                }));
                              }}
                            >
                              <span className="">Size: {item.selectSize}</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="6"
                                height="3"
                                viewBox="0 0 6 3"
                                className="itemComponents-base-dropDown"
                              >
                                <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                              </svg>
                            </div>
                          )}
                          <div
                            className="itemComponents-base-quantity"
                            onClick={(e) => {
                              e?.stopPropagation();
                              setShowOffCanvas((prev) => ({
                                show: !prev.show,
                                size: false,
                                product: item,
                              }));
                            }}
                          >
                            <span>Qty: {item?.quantity}</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="3"
                              viewBox="0 0 6 3"
                              className="itemComponents-base-dropDown"
                            >
                              <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                            </svg>
                          </div>
                        </Card.Text>

                        {item?.variants?.[0]?.price && (
                          <Card.Text
                            style={{ textAlign: "left" }}
                            className="mb-0"
                          >
                            <span style={{ fontWeight: 700 }}>
                              ₹{item?.variants[0]?.price}
                            </span>
                            <span
                              style={{
                                color: "#8d8d8d",
                                marginLeft: "5px",
                              }}
                            >
                              {/* MRP */}
                            </span>
                            {/* <span
                        style={{
                          color: "#8d8d8d",
                          marginLeft: "5px",
                          textDecoration: "line-through",
                        }}
                      >
                        ₹
                        {item?.variants[0]?.compare_at_price &&
                        parseInt(item?.variants[0]?.compare_at_price) > 0
                          ? item?.variants[0]?.compare_at_price
                          : item?.variants[0]?.price * 3}
                      </span> */}
                            <br />
                            {/* <span
                        style={{
                          color: "#ff4e4e",
                          marginLeft: "5px",
                        }}
                      >
                        {`${
    calculateDiscount(
      item?.variants?.[0]?.compare_at_price,
      item?.variants?.[0]?.price
    ) > 0 &&
      calculateDiscount(
        item?.variants?.[0]?.compare_at_price,
        item?.variants?.[0]?.price
      )
  } 
                 % OFF`}
                      </span> */}
                          </Card.Text>
                        )}
                        <Card.Text
                          style={{ textAlign: "left" }}
                          className="mb-0 mt-2"
                        >
                          <span className="me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="8"
                              viewBox="0 0 10 8"
                              fill="#03a685"
                            >
                              <path
                                fillRule="evenodd"
                                d="M9.775.227A.716.716 0 0 0 8.716.24L3.373 6.015a.09.09 0 0 1-.133 0L1.278 3.91a.716.716 0 0 0-1.059-.001.834.834 0 0 0 0 1.127l2.565 2.742c.14.15.33.223.53.223h.004a.71.71 0 0 0 .53-.23l5.939-6.416A.833.833 0 0 0 9.775.227"
                              ></path>
                            </svg>
                          </span>
                          <span className="fs-6 me-1">Delivery between</span>
                          <span className="fs-6 fw-semibold">
                            {`${new Date(
                              Date.now() + 5 * 24 * 60 * 60 * 1000,
                            ).getDate()} ${new Date(
                              Date.now() + 5 * 24 * 60 * 60 * 1000,
                            ).toLocaleString("default", {
                              month: "short",
                            })} `}{" "}
                            -{" "}
                            {`${new Date(
                              Date.now() + 8 * 24 * 60 * 60 * 1000,
                            ).getDate()} ${new Date(
                              Date.now() + 8 * 24 * 60 * 60 * 1000,
                            ).toLocaleString("default", { month: "short" })} `}
                          </span>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              {cartProducts?.length > 0 && (
                <div className="mt-4">
                  <div>
                    <h6 className="card-title text-start fw-bold border-bottom pb-2 pt-2">{`PRICE DETAILS(${selectedProduct?.length === 1
                      ? "1 Item"
                      : `${selectedProduct?.length} Items`
                      })`}</h6>
                    <div className="mt-3">
                      <div className="d-flex flex-row justify-content-between align-items-center ">
                        <span>Total MRP</span>
                        <span className="ms-2">
                          <span>
                            <span className="">₹</span>
                            {totalMRP}
                          </span>
                        </span>
                      </div>
                      {totalDiscount ? (
                        <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                          <span>Discount on MRP</span>
                          <span className="ms-2 text-success">
                            <span>
                              - <span className="">₹</span>
                              {totalDiscount}
                            </span>
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {totalExtraDiscount ? (
                        <>
                          <div className="d-flex flex-row justify-content-between align-items-center mt-2 border-top pt-2">
                            <span>Total Price</span>
                            <span className="ms-2">
                              <span>
                                <span className="">₹</span>
                                {totalMRP - totalDiscount}
                              </span>
                            </span>
                          </div>
                          <div className="d-flex flex-row justify-content-between align-items-center mt-2 ">
                            <span>Coupon Applied (Buy 2 Get 1 free)</span>
                            <span className="ms-2 text-success">
                              <span>
                                -<span className="">₹</span>
                                {totalExtraDiscount}
                              </span>
                            </span>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="d-flex flex-row justify-content-between align-items-center mt-2 fw-bold border-top pt-3">
                        <span>Total Amount</span>
                        <span className="ms-2">
                          <span>
                            <span className="">₹</span>
                            {totalPrice}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div>
                <Offcanvas
                  show={showOffCanvas.show}
                  onHide={(e) => {
                    e?.stopPropagation();
                    setShowOffCanvas((prev) => ({
                      ...prev,
                      show: !prev.show,
                      product: {},
                    }));
                  }}
                  placement={"bottom"}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                      Select {showOffCanvas.size ? "Size" : "Quantity"}
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className="d-flex align-items-center">
                      {showOffCanvas.size
                        ? showOffCanvas?.product?.size?.map((item, index) => (
                          <span
                            key={`${index} -cart - showOffCanvas`}
                            onClick={(e) => {
                              e?.stopPropagation();
                              setShowOffCanvas((prev) => ({
                                ...prev,
                                product: {
                                  ...prev.product,
                                  selectSize: item,
                                },
                              }));
                            }}
                            style={{
                              height: "50px",
                              width: "60px",
                              borderRadius: "10px",
                              border: "1px solid black",
                              padding: "25px",
                              background:
                                showOffCanvas?.product?.selectSize === item
                                  ? themColor
                                  : "#fff",
                              color:
                                showOffCanvas?.product?.selectSize === item
                                  ? "#fff"
                                  : "#000",
                            }}
                            className="d-flex justify-content-center align-items-center mx-2"
                          >
                            {item}
                          </span>
                        ))
                        : Array.from({ length: 5 }, (v, k) => k + 1)?.map(
                          (item, index) => (
                            <span
                              key={`${index} -single - pagination`}
                              onClick={(e) => {
                                e?.stopPropagation();
                                setShowOffCanvas((prev) => ({
                                  ...prev,
                                  product: {
                                    ...prev.product,
                                    quantity: item,
                                  },
                                }));
                              }}
                              style={{
                                height: "25px",
                                width: "25px",
                                borderRadius: "50%",
                                border: "1px solid black",
                                padding: "25px",
                                background:
                                  showOffCanvas?.product?.quantity === item
                                    ? themColor
                                    : "#fff",
                                color:
                                  showOffCanvas?.product?.quantity === item
                                    ? "#fff"
                                    : "#000",
                              }}
                              className="d-flex justify-content-center align-items-center mx-2"
                            >
                              {item}
                            </span>
                          ),
                        )}
                    </div>
                    <div className="mt-4 mb-3">
                      {showOffCanvas?.product?.price &&
                        (showOffCanvas?.product?.discount ? (
                          <p style={{ textAlign: "left" }} className="mb-0">
                            <span style={{ fontWeight: 700 }}>
                              ₹{showOffCanvas?.product?.discount}{" "}
                            </span>
                            <span
                              style={{
                                color: "#8d8d8d",
                                marginLeft: "5px",
                              }}
                            >
                              MRP
                            </span>
                            <span
                              style={{
                                color: "#8d8d8d",
                                marginLeft: "5px",
                                textDecoration: "line-through",
                              }}
                            >
                              ₹{showOffCanvas?.product?.price}
                            </span>
                            {/* <span
                        style={{
                          color: "#ff4e4e",
                          marginLeft: "5px",
                        }}
                      >{`(${(
      ((showOffCanvas?.product?.price -
        showOffCanvas?.product.discount) /
        showOffCanvas?.product?.price) *
      100
    ).toFixed(0)}) % OFF`}</span> */}
                          </p>
                        ) : (
                          <p style={{ textAlign: "left" }} className="mb-0">
                            {showOffCanvas?.product?.price}
                          </p>
                        ))}
                    </div>
                    <Button
                      onClick={(e) => {
                        e?.stopPropagation();
                        const oldData = cartProducts.map((item) => {
                          if (item.handle === showOffCanvas?.product?.handle) {
                            return showOffCanvas?.product;
                          } else {
                            return item;
                          }
                        });
                        handleSetCartProducts(oldData);
                        setSelectedProduct(oldData);
                        setShowOffCanvas((prev) => ({
                          ...prev,
                          show: !prev.show,
                          product: {},
                        }));
                      }}
                      variant="dark"
                      style={{
                        background: themColor,
                        borderColor: themColor,
                        width: "100%",
                        padding: "10px",
                      }}
                    >
                      Done
                    </Button>
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            </div>
            {cartProducts?.length > 0 && (
              <div className="position-sticky bottom-0 pb-3 bg-white">
                <div
                  className="mb-2"
                  style={{
                    backgroundColor: "#fff6f4",
                    fontSize: "12px",
                    padding: "4px 0 5px",
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#282c3f",
                  }}
                >
                  {selectedProduct?.length
                    ? `${selectedProduct?.length === 1
                      ? "1 Item"
                      : `${selectedProduct?.length} Items`
                    } selected for order`
                    : "No Item selected, select at least one item to place order."}
                </div>

                {routeChange ? (
                  <Button
                    className=""
                    variant="dark"
                    style={{
                      width: "100%",
                      padding: "10px",
                      background: process.env.REACT_APP_THEAM_COLOR,
                      borderColor: process.env.REACT_APP_THEAM_COLOR,
                      // color: "white",
                    }}
                    disabled={selectedProduct?.length === 0}
                    onClick={() => payNow()}
                  >
                    Pay Now
                  </Button>
                ) : (
                  <Button
                    style={{
                      width: "100%",
                      padding: "10px",
                      background: process.env.REACT_APP_THEAM_COLOR,
                      borderColor: process.env.REACT_APP_THEAM_COLOR,
                      // color: "white",
                    }}
                    disabled={selectedProduct?.length === 0}
                    onClick={(e) => {
                      e.stopPropagation();
                      setStep(2);
                      navigate("/checkout/address");
                    }}
                  >
                    Place Order
                  </Button>
                )}
              </div>
            )}
            <div className="mt-4">
              <img src={safetyImg} style={{ width: "100%" }} alt="" />
            </div>
          </Container>
        </div>
      ) : (
        //Desktop cart design
        <Container>
          <Row>
            <div className="my-5 d-flex">
              <Col lg={6}>
                <div>
                  {cartProducts?.map((item) => (
                    <Col key={item.id} className="mb-3">
                      <Card
                        className="flex-row align-items-center position-relative"
                        style={{ maxWidth: "500px" }}
                      >
                        {/* <div
                      className="product-select-box"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectProduct(item?.id);
                      }}
                    >
                      <Form.Check
                        className="custom-check-box d-flex"
                        type={"checkbox"}
                        checked={selectedProduct?.some((o) => o.id === item.id)}
                        onChange={() => {}}
                      />
                    </div> */}
                        <div
                          className="product-delete-box"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              selectedProduct?.find((o) => o.id === item.id)
                            ) {
                              handleSelectProduct(item.id);
                            }
                            const selectedItem = cartProducts.filter(
                              (o) => o.id !== item.id,
                            );
                            handleSetCartProducts(selectedItem);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill="#000"
                              fillRule="evenodd"
                              d="M9.031 8l6.756-6.756a.731.731 0 0 0 0-1.031.732.732 0 0 0-1.031 0L8 6.969 1.244.213a.732.732 0 0 0-1.031 0 .731.731 0 0 0 0 1.03L6.969 8 .213 14.756a.731.731 0 0 0 0 1.031.732.732 0 0 0 1.031 0L8 9.031l6.756 6.756a.732.732 0 0 0 1.031 0 .731.731 0 0 0 0-1.03L9.031 8z"
                            ></path>
                          </svg>
                        </div>
                        <div
                          style={{
                            width: "140px",
                            height: "180px",
                            padding: "10px",
                            borderRadius: "6px",
                          }}
                        >
                          <Card.Img
                            variant="top"
                            src={item?.images?.[0]?.src}
                            style={{
                              height: "100%",
                              minWidth: "100%",
                              borderRadius: "6px",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              navigate(`/ single - product / ${item.handle}`, {
                                state: {
                                  handle: item?.handler,
                                },
                              });
                            }}
                          />
                        </div>
                        <Card.Body style={{ textAlign: "start" }}>
                          <Card.Subtitle className="text-ellips">
                            {item.title}
                          </Card.Subtitle>
                          <Card.Text className="d-flex align-items-center mt-2 mb-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill="#FF3F6C"
                                d="M7.998 4c-2.674 0-5.1 1.57-6.888 4.12a.625.625 0 000 .709c1.789 2.552 4.214 4.122 6.888 4.122 2.674 0 5.099-1.57 6.888-4.12a.629.629 0 000-.709C13.096 5.57 10.672 4 7.998 4zm.192 7.627c-1.775.12-3.241-1.45-3.13-3.357.092-1.573 1.28-2.848 2.746-2.946 1.775-.12 3.24 1.45 3.13 3.357-.095 1.57-1.283 2.845-2.746 2.946zm-.09-1.456c-.955.064-1.746-.78-1.683-1.806.05-.848.69-1.533 1.48-1.588.957-.065 1.747.78 1.684 1.806-.051.85-.693 1.536-1.48 1.588z"
                              ></path>
                            </svg>
                            <span
                              className=""
                              style={{
                                fontSize: "12px",
                                fontWeight: 700,
                                paddingLeft: "3px",
                                color: "#282c3f",
                              }}
                            >
                              {Math.floor(Math.random() * 31) + 50}
                            </span>
                            <span
                              className=""
                              style={{
                                color: "#94969f",
                                fontSize: "12px",
                                paddingLeft: "3px",
                              }}
                            >
                              People viewing now
                            </span>
                          </Card.Text>

                          <Card.Text className="mt-1">
                            {item?.size?.length > 0 && (
                              <div
                                className="itemComponents-base-quantity me-2"
                                onClick={(e) => {
                                  e?.stopPropagation();
                                  setShowOffCanvas((prev) => ({
                                    show: !prev.show,
                                    size: true,
                                    product: item,
                                  }));
                                }}
                              >
                                <span className="">
                                  Size: {item.selectSize}
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="6"
                                  height="3"
                                  viewBox="0 0 6 3"
                                  className="itemComponents-base-dropDown"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M0 0h6L3 3z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                            <div
                              className="itemComponents-base-quantity"
                              onClick={(e) => {
                                e?.stopPropagation();
                                setShowOffCanvas((prev) => ({
                                  show: !prev.show,
                                  size: false,
                                  product: item,
                                }));
                              }}
                            >
                              <span>Qty: {item?.quantity}</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="6"
                                height="3"
                                viewBox="0 0 6 3"
                                className="itemComponents-base-dropDown"
                              >
                                <path fillRule="evenodd" d="M0 0h6L3 3z"></path>
                              </svg>
                            </div>
                          </Card.Text>

                          {item?.variants?.[0]?.price && (
                            <Card.Text
                              style={{ textAlign: "left" }}
                              className="mb-0"
                            >
                              <span style={{ fontWeight: 700 }}>
                                ₹{item?.variants[0]?.price}
                              </span>
                              <span
                                style={{
                                  color: "#8d8d8d",
                                  marginLeft: "5px",
                                }}
                              >
                                {/* MRP */}
                              </span>
                              {/* <span
                        style={{
                          color: "#8d8d8d",
                          marginLeft: "5px",
                          textDecoration: "line-through",
                        }}
                      >
                        ₹
                        {item?.variants[0]?.compare_at_price &&
                        parseInt(item?.variants[0]?.compare_at_price) > 0
                          ? item?.variants[0]?.compare_at_price
                          : item?.variants[0]?.price * 3}
                      </span> */}
                              <br />
                              {/* <span
                        style={{
                          color: "#ff4e4e",
                          marginLeft: "5px",
                        }}
                      >
                        {`${
  calculateDiscount(
    item?.variants?.[0]?.compare_at_price,
    item?.variants?.[0]?.price
  ) > 0 &&
    calculateDiscount(
      item?.variants?.[0]?.compare_at_price,
      item?.variants?.[0]?.price
    )
} 
                 % OFF`}
                      </span> */}
                            </Card.Text>
                          )}
                          <Card.Text
                            style={{ textAlign: "left" }}
                            className="mb-0 mt-2"
                          >
                            <span className="me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="8"
                                viewBox="0 0 10 8"
                                fill="#03a685"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M9.775.227A.716.716 0 0 0 8.716.24L3.373 6.015a.09.09 0 0 1-.133 0L1.278 3.91a.716.716 0 0 0-1.059-.001.834.834 0 0 0 0 1.127l2.565 2.742c.14.15.33.223.53.223h.004a.71.71 0 0 0 .53-.23l5.939-6.416A.833.833 0 0 0 9.775.227"
                                ></path>
                              </svg>
                            </span>
                            <span className="fs-6 me-1">Delivery between</span>
                            <span className="fs-6 fw-semibold">
                              {`${new Date(
                                Date.now() + 5 * 24 * 60 * 60 * 1000,
                              ).getDate()} ${new Date(
                                Date.now() + 5 * 24 * 60 * 60 * 1000,
                              ).toLocaleString("default", {
                                month: "short",
                              })} `}{" "}
                              -{" "}
                              {`${new Date(
                                Date.now() + 8 * 24 * 60 * 60 * 1000,
                              ).getDate()} ${new Date(
                                Date.now() + 8 * 24 * 60 * 60 * 1000,
                              ).toLocaleString("default", {
                                month: "short",
                              })} `}
                            </span>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  {cartProducts?.length > 0 && (
                    <div className="">
                      <div>
                        <h6 className="card-title text-start fw-bold border-bottom pb-2 pt-2">{`PRICE DETAILS(${selectedProduct?.length === 1
                          ? "1 Item"
                          : `${selectedProduct?.length} Items`
                          })`}</h6>
                        <div className="mt-3">
                          <div className="d-flex flex-row justify-content-between align-items-center ">
                            <span>Total MRP</span>
                            <span className="ms-2">
                              <span>
                                <span className="">₹</span>
                                {totalMRP}
                              </span>
                            </span>
                          </div>
                          {totalDiscount ? (
                            <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                              <span>Discount on MRP</span>
                              <span className="ms-2 text-success">
                                <span>
                                  - <span className="">₹</span>
                                  {totalDiscount}
                                </span>
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                          {totalExtraDiscount ? (
                            <>
                              <div className="d-flex flex-row justify-content-between align-items-center mt-2 border-top pt-2">
                                <span>Total Price</span>
                                <span className="ms-2">
                                  <span>
                                    <span className="">₹</span>
                                    {totalMRP - totalDiscount}
                                  </span>
                                </span>
                              </div>
                              <div className="d-flex flex-row justify-content-between align-items-center mt-2 ">
                                <span>Coupon Applied (Buy 2 Get 1 free)</span>
                                <span className="ms-2 text-success">
                                  <span>
                                    -<span className="">₹</span>
                                    {totalExtraDiscount}
                                  </span>
                                </span>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          <div className="d-flex flex-row justify-content-between align-items-center mt-2 fw-bold border-top pt-3">
                            <span>Total Amount</span>
                            <span className="ms-2">
                              <span>
                                <span className="">₹</span>
                                {totalPrice}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    {cartProducts?.length > 0 && (
                      <div className="position-sticky bottom-0 pb-3 bg-white">
                        <div
                          className="mb-2"
                          style={{
                            backgroundColor: "#fff6f4",
                            fontSize: "12px",
                            padding: "4px 0 5px",
                            textAlign: "center",
                            fontWeight: 700,
                            color: "#282c3f",
                          }}
                        >
                          {selectedProduct?.length
                            ? `${selectedProduct?.length === 1
                              ? "1 Item"
                              : `${selectedProduct?.length} Items`
                            } selected for order`
                            : "No Item selected, select at least one item to place order."}
                        </div>

                        {routeChange ? (
                          <Button
                            className=""
                            variant="dark"
                            style={{
                              width: "100%",
                              padding: "10px",
                              background: process.env.REACT_APP_THEAM_COLOR,
                              borderColor: process.env.REACT_APP_THEAM_COLOR,
                              // color: "white",
                            }}
                            disabled={selectedProduct?.length === 0}
                            onClick={() => payNow()}
                          >
                            Pay Now
                          </Button>
                        ) : (
                          <Button
                            style={{
                              width: "100%",
                              padding: "10px",
                              background: process.env.REACT_APP_THEAM_COLOR,
                              borderColor: process.env.REACT_APP_THEAM_COLOR,
                              // color: "white",
                            }}
                            disabled={selectedProduct?.length === 0}
                            onClick={(e) => {
                              e.stopPropagation();
                              setStep(2);
                              navigate("/checkout/address");
                            }}
                          >
                            Place Order
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    <Offcanvas
                      show={showOffCanvas.show}
                      onHide={(e) => {
                        e?.stopPropagation();
                        setShowOffCanvas((prev) => ({
                          ...prev,
                          show: !prev.show,
                          product: {},
                        }));
                      }}
                      placement={"end"}
                    >
                      <Offcanvas.Header closeButton>
                        <Offcanvas.Title>
                          Select {showOffCanvas.size ? "Size" : "Quantity"}
                        </Offcanvas.Title>
                      </Offcanvas.Header>
                      <Offcanvas.Body>
                        <div className="d-flex align-items-center">
                          {showOffCanvas.size
                            ? showOffCanvas?.product?.size?.map(
                              (item, index) => (
                                <span
                                  key={`${index} - cart - showOffCanvas`}
                                  onClick={(e) => {
                                    e?.stopPropagation();
                                    setShowOffCanvas((prev) => ({
                                      ...prev,
                                      product: {
                                        ...prev.product,
                                        selectSize: item,
                                      },
                                    }));
                                  }}
                                  style={{
                                    height: "50px",
                                    width: "60px",
                                    borderRadius: "10px",
                                    border: "1px solid black",
                                    padding: "25px",
                                    background:
                                      showOffCanvas?.product?.selectSize ===
                                        item
                                        ? themColor
                                        : "#fff",
                                    color:
                                      showOffCanvas?.product?.selectSize ===
                                        item
                                        ? "#fff"
                                        : "#000",
                                  }}
                                  className="d-flex justify-content-center align-items-center mx-2"
                                >
                                  {item}
                                </span>
                              ),
                            )
                            : Array.from({ length: 5 }, (v, k) => k + 1)?.map(
                              (item, index) => (
                                <span
                                  key={`${index} -single - pagination`}
                                  onClick={(e) => {
                                    e?.stopPropagation();
                                    setShowOffCanvas((prev) => ({
                                      ...prev,
                                      product: {
                                        ...prev.product,
                                        quantity: item,
                                      },
                                    }));
                                  }}
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    borderRadius: "50%",
                                    border: "1px solid black",
                                    padding: "25px",
                                    background:
                                      showOffCanvas?.product?.quantity ===
                                        item
                                        ? themColor
                                        : "#fff",
                                    color:
                                      showOffCanvas?.product?.quantity ===
                                        item
                                        ? "#fff"
                                        : "#000",
                                  }}
                                  className="d-flex justify-content-center align-items-center mx-2"
                                >
                                  {item}
                                </span>
                              ),
                            )}
                        </div>
                        <div className="mt-4 mb-3">
                          {showOffCanvas?.product?.price &&
                            (showOffCanvas?.product?.discount ? (
                              <p style={{ textAlign: "left" }} className="mb-0">
                                <span style={{ fontWeight: 700 }}>
                                  ₹{showOffCanvas?.product?.discount}{" "}
                                </span>
                                <span
                                  style={{
                                    color: "#8d8d8d",
                                    marginLeft: "5px",
                                  }}
                                >
                                  MRP
                                </span>
                                <span
                                  style={{
                                    color: "#8d8d8d",
                                    marginLeft: "5px",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  ₹{showOffCanvas?.product?.price}
                                </span>
                                {/* <span
                        style={{
                          color: "#ff4e4e",
                          marginLeft: "5px",
                        }}
                      >{`(${(
  ((showOffCanvas?.product?.price -
    showOffCanvas?.product.discount) /
    showOffCanvas?.product?.price) *
  100
).toFixed(0)}) % OFF`}</span> */}
                              </p>
                            ) : (
                              <p style={{ textAlign: "left" }} className="mb-0">
                                {showOffCanvas?.product?.price}
                              </p>
                            ))}
                        </div>
                        <Button
                          onClick={(e) => {
                            e?.stopPropagation();
                            const oldData = cartProducts.map((item) => {
                              if (
                                item.handle === showOffCanvas?.product?.handle
                              ) {
                                return showOffCanvas?.product;
                              } else {
                                return item;
                              }
                            });
                            handleSetCartProducts(oldData);
                            setSelectedProduct(oldData);
                            setShowOffCanvas((prev) => ({
                              ...prev,
                              show: !prev.show,
                              product: {},
                            }));
                          }}
                          variant="dark"
                          style={{
                            background: themColor,
                            borderColor: themColor,
                            width: "100%",
                            padding: "10px",
                          }}
                        >
                          Done
                        </Button>
                      </Offcanvas.Body>
                    </Offcanvas>
                  </div>
                </div>
              </Col>
            </div>
          </Row>
          <div>
            {cartProducts?.length === 0 && (
              <div
                style={{
                  boxShadow: "1px 1px 11px 1px #ddd",
                  padding: "10px",
                  marginTop: "20px",
                  borderRadius: "15px",
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Outline"
                    viewBox="0 0 24 24"
                    width="50"
                    height="50"
                  >
                    <path d="M21,6H18A6,6,0,0,0,6,6H3A3,3,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A3,3,0,0,0,21,6ZM12,2a4,4,0,0,1,4,4H8A4,4,0,0,1,12,2ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A1,1,0,0,1,3,8H6v2a1,1,0,0,0,2,0V8h8v2a1,1,0,0,0,2,0V8h3a1,1,0,0,1,1,1Z" />
                  </svg>
                </div>
                <h2
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  Your cart is empty
                </h2>
                <div className="Footer__Content Rte">
                  Let's go Buy Somthing!
                </div>
                <Button
                  variant="dark"
                  className="btn my-3 primary d-flex justify-content-center align-items-center ripple animated"
                  style={{
                    padding: "10px 20px",
                    background: "var(--them-color)",
                    borderColor: "var(--them-color)",
                  }}
                  onClick={(e) => {
                    e?.target?.classList?.add("bounceIn");
                    navigate(`/ `);
                    setTimeout(() => {
                      if (e?.target?.classList?.contains("bounceIn"))
                        e?.target?.classList?.remove("bounceIn");
                    }, 1000);
                  }}
                >
                  Shop Now
                </Button>
              </div>
            )}
          </div>
        </Container>
      )}
    </>
  );
};

export default Cart;
